import { defineMessages } from 'react-intl';
import {
  CardsAppearance,
  CardsWithImageAppearance,
  CarouselHead,
  CarouselReadMoreButton,
} from '@redturtle/volto-io-studio/components/Blocks';

const messages = defineMessages({
  pre_title: {
    id: 'listing_carousel_pre_title',
    defaultMessage: 'Pre titolo',
  },
  description: {
    id: 'listing_carousel_description',
    defaultMessage: 'Descrizione',
  },
});

const addSchemaField = (schema, fieldset, beforeField, field, properties) => {
  let fieldsetIndex = schema.fieldsets.findIndex((x) => x.id === fieldset);
  let position = schema.fieldsets[fieldsetIndex]?.fields.indexOf(beforeField);

  schema.fieldsets[fieldsetIndex]?.fields?.splice(position, 0, field);
  schema.properties[field] = properties;
};

const applyListingCarouselConfig = (config) => {
  config.settings['volto-rt-carousel'] = {
    ...(config.settings['volto-rt-carousel'] ?? {}),
    slots: {
      ...(config.settings['volto-rt-carousel']?.slots ?? {}),
      top: { component: CarouselHead },
      bottom: { component: CarouselReadMoreButton },
    },
    slide_appearances: {
      ...(config.settings['volto-rt-carousel'].slide_appearances ?? {}),
      cards: {
        name: 'Cards',
        component: CardsAppearance,
      },
      cards_with_image: {
        name: 'Cards con immagine',
        component: CardsWithImageAppearance,
      },
    },
  };
  config.blocks.blocksConfig.listing.variations.forEach((v) => {
    if (v.id === 'carousel') {
      const defaultSchemaEnhancer = v.schemaEnhancer;
      v.schemaEnhancer = ({ schema, formData, intl }) => {
        schema = defaultSchemaEnhancer({ schema, formData, intl });

        addSchemaField(schema, 'default', 'head_position', 'pre_title', {
          title: intl.formatMessage(messages.pre_title),
        });

        addSchemaField(schema, 'default', 'head_position', 'description', {
          title: intl.formatMessage(messages.description),
          widget: 'textarea',
        });
        return schema;
      };
    }
  });
};
export default applyListingCarouselConfig;
